import {
  all,
  cancelled,
  delay,
  put,
  takeEvery,
  takeLatest
} from "@redux-saga/core/effects";
import { isValidString } from "../../front-end-global-components/services/validators";
import {
  abhaAddressResetPassword,
  acceptAutoApprove,
  acceptRequest,
  confirmLoginForAbdmAuth,
  confirmUnlinkAbhaAddressFromAbhaNumber,
  createAutoApprovalPolicy,
  createHealthId,
  deLinkAbhaNumber,
  denyRequests,
  disableAutoApprovalPolicy,
  editHealthIdData,
  editSubscriptionRequest,
  generateLinkingToken,
  generateOtpForAbdmAuth,
  generateOtpForUnlinkAbhaAddressFromAbhaNumber,
  generateOTPForUpdatePhoneNumberOrEmail,
  getCareContexts,
  getConsentArtefact,
  getHealthIdData,
  getModesForAbdmAuth,
  getPatientRequests,
  getUpdatedConsentArtefactRequest,
  getUpdatedRequest,
  linkAbhaNumber,
  linkOrUnlinkAbhaAddressFromAbhaNumber,
  lockerAuthorizationRequest,
  refreshABDMToken,
  revokeRequest,
  searchABHANumber,
  switchProfile,
  verifyOtpForAbdmAuth,
  verifyOTPForUpdatePhoneNumberOrEmail
} from "../../services/api";
import { signInWithAuthCustomToken } from "../../services/authentication";
import {
  addConsentAgreeToPersonalData,
  createDemographic
} from "../../services/database";
import { isAbdmSessionError, throwError } from "../../services/error";
import {
  consentStatus,
  formatABHANumber,
  generateEncryptionValue,
  getValidAbhaMethod,
  getValidAuthMode
} from "../../utils/constants";
import { isValidArray, isValidObject } from "../../utils/validators";
import { logout, putAuthInfo } from "../authentication/actions";
import { setErrorStatus, setSuccessStatus } from "../status/actions";
import store from "../store/store";
import {
  getHealthIdInformation,
  setAuthModes,
  setTransactionId
} from "./actions";

export const patientsActionTypes = {
  /* =======================
   * AUTHENTICATION & LOGIN
   * ======================= */
  GET_MODES_FOR_ABDM_AUTH: "GET_MODES_FOR_ABDM_AUTH",
  SEND_OTP_FOR_ABDM_AUTHENTICATION: "SEND_OTP_FOR_ABDM_AUTHENTICATION",
  VERIFY_ABDM_AUTHENTICATION_OTP: "VERIFY_ABDM_AUTHENTICATION_OTP",
  CONFIRM_ABDM_LOGIN: "CONFIRM_ABDM_LOGIN",
  LOGOUT_HEALTH_ID: "LOGOUT_HEALTH_ID",
  SET_AUTH_MODES: "SET_AUTH_MODES",
  SEARCH_HEALTH_ID_AUTH_MODE: "SEARCH_HEALTH_ID_AUTH_MODE",

  /* =======================
   * HEALTH ID & PROFILE
   * ======================= */
  CREATE_HEALTH_ID: "CREATE_HEALTH_ID",
  GET_HEALTH_ID_INFORMATION: "GET_HEALTH_ID_INFORMATION",
  SWITCH_PATIENT_PROFILE: "SWITCH_PATIENT_PROFILE",
  EDIT_PROFILE: "EDIT_PROFILE",
  RESET_ABHA_PASSWORD: "RESET_ABHA_PASSWORD",
  CLEAR_ABDM_UNUSED_HEALTH_ID: "CLEAR_ABDM_UNUSED_HEALTH_ID",
  CLEAR_ABDM_LINKED_PROFILES: "CLEAR_ABDM_LINKED_PROFILES",

  /* =======================
   * LINKING & TOKENS
   * ======================= */
  GET_NEW_LINKING_TOKEN: "GET_NEW_LINKING_TOKEN",
  LINKING_TOKEN_DETAILS: "LINKING_TOKEN_DETAILS",
  PUT_TRANSACTION_ID: "PUT_TRANSACTION_ID",

  /* =======================
   * DEMOGRAPHICS
   * ======================= */
  ADD_PATIENTS_DEMOGRAPHICS: "ADD_PATIENTS_DEMOGRAPHICS",
  CREATE_PATIENTS_DEMOGRAPHIC: "CREATE_PATIENTS_DEMOGRAPHIC",

  /* =======================
   * CARE CONTEXTS
   * ======================= */
  GET_PATIENTS_CARE_CONTEXTS: "GET_PATIENTS_CARE_CONTEXTS",
  SELECTED_LINKED_FACILITY: "SELECTED_LINKED_FACILITY",

  /* =======================
   * CONSENT & AUTHORIZATION
   * ======================= */
  GET_PATIENTS_CONSENT_ARTEFACT: "GET_PATIENTS_CONSENT_ARTEFACT",
  CHECK_CONSENT_PIN_EXISTS: "CHECK_CONSENT_PIN_EXISTS",
  SET_CONSENT_TO_PERSONAL_DATA: "SET_CONSENT_TO_PERSONAL_DATA",

  ACCEPT_CONSENT_REQUEST: "ACCEPT_CONSENT_REQUEST",
  DENY_CONSENT_REQUEST: "DENY_CONSENT_REQUEST",
  REVOKE_CONSENT_REQUEST: "REVOKE_CONSENT_REQUEST",

  ACCEPT_AUTHORIZATION_REQUEST: "ACCEPT_AUTHORIZATION_REQUEST",
  DENY_AUTHORIZATION_REQUEST: "DENY_AUTHORIZATION_REQUEST",
  REVOKE_AUTHORIZATION_REQUEST: "REVOKE_AUTHORIZATION_REQUEST",

  /* =======================
   * SUBSCRIPTIONS
   * ======================= */
  GET_PATIENTS_REQUESTS: "GET_PATIENTS_REQUESTS",
  SCHEDULE_PATIENTS_REQUESTS_REFRESH: "SCHEDULE_PATIENTS_REQUESTS_REFRESH",
  GET_PATIENTS_UPDATED_REQUESTS: "GET_PATIENTS_UPDATED_REQUESTS",
  ADD_PATIENTS_SUBSCRIPTION: "ADD_PATIENTS_SUBSCRIPTION",
  ACCEPT_SUBSCRIPTION_REQUEST: "ACCEPT_SUBSCRIPTION_REQUEST",
  DENY_SUBSCRIPTION_REQUEST: "DENY_SUBSCRIPTION_REQUEST",

  /* =======================
   * HEALTH LOCKER
   * ======================= */
  ACCEPT_LOCKER_REQUEST: "ACCEPT_LOCKER_REQUEST",
  HEALTH_LOCKER_AUTHORIZATION: "HEALTH_LOCKER_AUTHORIZATION",

  /* =======================
   * AUTO APPROVAL
   * ======================= */
  ADD_AUTO_APPROVAL_POLICIES: "ADD_AUTO_APPROVAL_POLICIES",
  CREATE_AUTO_APPROVE: "CREATE_AUTO_APPROVE",
  ENABLE_AUTO_APPROVE: "ENABLE_AUTO_APPROVE",
  DISABLE_AUTO_APPROVE: "DISABLE_AUTO_APPROVE",

  /* =======================
   * ABHA LINK / UNLINK
   * ======================= */
  GENERATE_LINK_OR_UNLINK_ABHA_ADDRESS_OTP:
    "GENERATE_LINK_OR_UNLINK_ABHA_ADDRESS_OTP",
  CONFIRM_LINK_OR_UNLINK_ABHA_ADDRESS: "CONFIRM_LINK_OR_UNLINK_ABHA_ADDRESS",
  LINK_HEALTH_ID_NUMBER: "LINK_HEALTH_ID_NUMBER",

  /* =======================
   * PHONE / EMAIL UPDATE
   * ======================= */
  SAVE_EDIT_PROFILE: "SAVE_EDIT_PROFILE",
  GENERATE_OTP_TO_UPDATE_PHONE_NUMBER_OR_EMAIL:
    "GENERATE_OTP_TO_UPDATE_PHONE_NUMBER_OR_EMAIL",
  VERIFY_OTP_TO_UPDATE_PHONE_NUMBER_OR_EMAIL:
    "VERIFY_OTP_TO_UPDATE_PHONE_NUMBER_OR_EMAIL",
  CHANGE_PHONE_NUMBER: "CHANGE_PHONE_NUMBER",

  /* =======================
   * UI / STATE
   * ======================= */
  SET_REQUESTS_FILTER_DATA: "SET_REQUESTS_FILTER_DATA",
  ACTIVE_SETTINGS_MENU: "ACTIVE_SETTINGS_MENU",
  CLEAR_SHOW_SUCCESS: "CLEAR_SHOW_SUCCESS"
};

function* addPatientsDemographicsWorker(action) {
  const { auth } = store.getState();
  if (isValidArray(auth.data.validProfiles)) {
    const validHealthIds =
      auth.data.validProfiles?.map((p) => p?.abhaAddress) || [];

    const filteredProfiles = Object.fromEntries(
      Object.entries(action.payload || {}).filter(([_, profile]) =>
        validHealthIds.includes(profile?.healthId)
      )
    );

    yield put({
      type: "SET_PATIENTS_DEMOGRAPHICS",
      payload: filteredProfiles
    });
    return;
  }
  yield put({
    type: "SET_PATIENTS_DEMOGRAPHICS",
    payload: action.payload
  });
}

function* switchPatientsWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { auth, patients } = store.getState();
    if (action.payload.profileId) {
      yield put({
        type: "SET_CURRENT_PATIENT_PROFILE_ID",
        payload: { currentProfile: action.payload.profileId }
      });
    }

    const { transactionId, accessToken, abdmToken, isABHANumberRegister } =
      auth.data || {};

    const { accessToken: patientTokens, loginType, profiles } = patients;

    const currentProfileData = profiles?.[action.payload.profileId];
    const currentTokens =
      patientTokens?.[action.payload.profileId]?.token &&
      patientTokens?.[action.payload.profileId]?.refreshToken;
    const healthId = currentProfileData?.healthId;

    if (
      transactionId &&
      action.payload.profileId &&
      !currentTokens &&
      loginType !== "password" &&
      healthId &&
      abdmToken
    ) {
      const switchResponse = isABHANumberRegister
        ? yield confirmLoginForAbdmAuth(accessToken, abdmToken, action.payload)
        : yield switchProfile(accessToken, action.payload.profileId, {
            token: abdmToken,
            healthId
          });

      yield put({
        type: "SET_ABDM_ACCESS_TOKEN",
        payload: {
          abdmAccessToken: {
            ...patients.accessToken,
            [action.payload.profileId]: switchResponse?.data
          }
        }
      });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* clearUnusedHealthId() {
  yield put({
    type: "SET_ABDM_UNUSED_HEALTH_ID",
    payload: {
      healthId: null
    }
  });
}

function* clearABDMLinkedProfiles() {
  yield put({
    type: "SET_LINKED_PROFILES",
    payload: { linkedProfiles: null }
  });
  yield put({
    type: "SET_IS_MULTIPLE_LOGIN",
    payload: { data: false }
  });
}

function* clearShowSuccess() {
  yield put({
    type: "SET_SHOW_SUCCESS",
    payload: {
      data: {
        healthId: {
          created: false,
          link: false,
          unLink: false
        }
      }
    }
  });
}

function* sendOtpForAbdmAuthWorker(action) {
  try {
    yield setPatientsLoading(true);

    const authData = store.getState().auth.data;
    const { authType, auth, method, value } = action.payload;

    yield put({
      type: "SET_ABDM_UNUSED_HEALTH_ID",
      payload: { healthId: null }
    });

    const authMode = getValidAuthMode(authType);

    yield put({
      type: "SET_PATIENTS_LOGIN_TYPE",
      payload: { loginType: authMode === "PASSWORD" ? "password" : "OTP" }
    });

    const validAuthMode = getValidAbhaMethod(method);
    const isAbhaAddressMethod = validAuthMode === "ABHAADDRESS";
    const isAbhaNumberMethod = validAuthMode === "ABHANUMBER";
    const isPhoneNumbersMethod = validAuthMode === "MOBILE_OTP";
    const isAadhaarNumbersMethod = validAuthMode === "AADHAAR";

    console.log(value, "value");

    const response = yield generateOtpForAbdmAuth(authData?.accessToken, auth, {
      value:
        isAbhaNumberMethod || isAadhaarNumbersMethod
          ? generateEncryptionValue(formatABHANumber(value), "ABHA")
          : isPhoneNumbersMethod || isAbhaAddressMethod
          ? generateEncryptionValue(
              isPhoneNumbersMethod ? value.replace("+91", "") : value,
              "PHR"
            )
          : value,
      authMode: validAuthMode,
      ...(isAbhaNumberMethod || isAbhaAddressMethod
        ? { otpType: authMode }
        : {})
    });

    const { data } = response;

    const transactionIdOrSessionId = data?.transactionId || data?.sessionId;

    if (transactionIdOrSessionId) {
      setTransactionId(
        transactionIdOrSessionId,
        isAbhaNumberMethod ? null : value
      );

      yield put({
        type: "SET_AUTH_INFO",
        payload: {
          ...store.getState().auth.data,
          transactionId: transactionIdOrSessionId,
          authMode
        }
      });
    }

    if (data?.message) {
      setSuccessStatus(data.message);
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* getModesForAbdmAuthWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { accessToken } = store.getState().auth.data;
    const { auth, method, value } = action.payload;

    if (method === "ABHA Number") {
      const response = yield searchABHANumber(accessToken, {
        value: formatABHANumber(value)
      });

      if (response?.success && isValidArray(response?.data?.authMethods)) {
        setAuthModes(response.data.authMethods);
      }
    } else {
      const result = yield getModesForAbdmAuth(accessToken, auth, value);

      if (isValidArray(result?.data?.authMethods)) {
        setAuthModes(result.data.authMethods);
      } else {
        setErrorStatus({
          code: "custom",
          message: "No valid auth mode available. Please try later"
        });
      }
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);

    setErrorStatus(error);
  }
}

function* verifyAbdmAuthOtpWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { patients } = store.getState();
    const authData = store.getState().auth.data;

    const {
      auth,
      method,
      otp,
      navigate,
      skipHealthInfo,
      healthId,
      phoneNumber,
      selectedAuthMethod
    } = action.payload;

    const transactionId = patients?.transaction?.id;
    const validAuthMode = getValidAbhaMethod(method);

    const isAbhaAddressMethod = validAuthMode === "ABHAADDRESS";
    const isAbhaNumberMethod = validAuthMode === "ABHANUMBER";
    const isPhoneNumbersMethod = validAuthMode === "MOBILE_OTP";
    const isAadhaarNumbersMethod = validAuthMode === "AADHAAR";

    const authMode = getValidAuthMode(selectedAuthMethod);

    const verifyResponse = yield verifyOtpForAbdmAuth(
      authData?.accessToken,
      auth,
      {
        otp: generateEncryptionValue(
          otp,
          isAbhaNumberMethod || isAadhaarNumbersMethod ? "ABHA" : "PHR"
        ),
        authMode: validAuthMode,
        ...(isAbhaAddressMethod || isAbhaNumberMethod
          ? { otpType: authMode }
          : {}),
        ...(transactionId ? { transactionId } : {}),
        ...(isAbhaAddressMethod ? { healthId } : {}),
        ...(isPhoneNumbersMethod
          ? {
              phoneNumber
              // generateEncryptionValue(
              //   phoneNumber.replace("+91", ""),
              //   "PHR"
              // )
            }
          : {})
      }
    );

    if (auth === "login") {
      const { success, data } = verifyResponse;

      if (data?.listOfProfiles) {
        yield put({
          type: "SET_AUTH_INFO",
          payload: {
            ...store.getState().auth.data,
            validProfiles: data?.listOfProfiles
          }
        });

        const validHealthIds =
          data?.listOfProfiles?.map((p) => p?.abhaAddress) || [];

        const filteredProfiles = Object.fromEntries(
          Object.entries(store.getState().patients.profiles || {}).filter(
            ([_, profile]) => validHealthIds.includes(profile?.healthId)
          )
        );

        yield put({
          type: "SET_PATIENTS_DEMOGRAPHICS",
          payload: filteredProfiles
        });
      }

      if (patients?.currentProfile) {
        yield put({
          type: "SET_CURRENT_PATIENT_PROFILE_ID",
          payload: { currentProfile: null }
        });
      }

      if (success === false) {
        setErrorStatus({
          code: "custom",
          message: data?.message
        });
      }

      if (success === true && data?.otpValidation) {
        setSuccessStatus(data.message);

        if (data?.token && authData?.phoneNumber === data?.phoneNumber) {
          if (isAbhaAddressMethod) {
            if (data?.patient?.patientId) {
              yield put({
                type: "SET_CURRENT_PATIENT_PROFILE_ID",
                payload: { currentProfile: data?.patient?.patientId }
              });

              yield put({
                type: "SET_ABDM_ACCESS_TOKEN",
                payload: {
                  abdmAccessToken: {
                    ...patients.accessToken,
                    [data?.patient?.patientId]: {
                      token: data.token,
                      ...(data?.refreshToken
                        ? { refreshToken: data.refreshToken }
                        : {})
                    }
                  }
                }
              });

              yield put({
                type: "SET_AUTH_INFO",
                payload: {
                  ...store.getState().auth.data,
                  authMode: "ABHAADDRESS",
                  ...(data.refreshToken
                    ? { ABDMRefreshToken: data.refreshToken }
                    : {})
                }
              });
            }

            if (!skipHealthInfo) {
              yield setAbdmHealthIds(action.payload.requestValue);
            }
            setAuthModes(null);
            setTransactionId(null);
          } else {
            yield put({
              type: "SET_AUTH_INFO",
              payload: {
                ...store.getState().auth.data,
                abdmToken: data.token,
                ABDMRefreshToken: data.refreshToken
              }
            });
          }

          navigate("/switchProfile", { replace: true });
          yield setPatientsLoading(false);
          return;
        }

        if (isValidArray(data?.linkedProfiles)) {
          yield put({
            type: "SET_LINKED_PROFILES",
            payload: { linkedProfiles: data.linkedProfiles }
          });

          const [profile] = data.linkedProfiles;

          if (data?.token && authData?.phoneNumber !== data.phoneNumber) {
            yield switchWithCustomToken(
              profile?.customToken,
              data?.transactionId,
              data?.token,
              validAuthMode,
              data?.listOfProfiles
            );

            if (data.refreshToken) {
              yield put({
                type: "SET_AUTH_INFO",
                payload: {
                  ...store.getState().auth.data,
                  ABDMRefreshToken: data.refreshToken
                }
              });
            }

            yield setAbdmHealthIds(
              data?.listOfProfiles?.map((e) => e.abhaAddress)
            );

            if (data.patient?.patientId) {
              yield put({
                type: "SET_CURRENT_PATIENT_PROFILE_ID",
                payload: { currentProfile: data.patient?.patientId }
              });

              yield put({
                type: "SET_ABDM_ACCESS_TOKEN",
                payload: {
                  abdmAccessToken: {
                    ...patients.accessToken,
                    [data?.patient?.patientId]: {
                      token: data.token,
                      ...(data.refreshToken
                        ? { refreshToken: data.refreshToken }
                        : {})
                    }
                  }
                }
              });
            }

            navigate("/", { replace: true });
          }
        }
      }
    }

    if (auth === "register") {
      const { success, data } = verifyResponse;

      const transactionId = data?.txnId || data?.sessionId;

      if (success === false) {
        setErrorStatus({
          code: "custom",
          message: data?.message
        });
      }

      if (success === true && transactionId) {
        setSuccessStatus(data.message);
        yield put({
          type: "SET_AUTH_INFO",
          payload: {
            ...store.getState().auth.data,
            transactionId,
            ...(data.tokens.token ? { abdmToken: data.tokens.token } : {}),
            ...(data.tokens.refreshToken
              ? { ABDMRefreshToken: data.tokens.token }
              : {}),
            ...(data?.customToken &&
            data?.accounts?.[0]?.mobile !==
              store.getState().auth.data?.phoneNumber?.replace("+91", "")
              ? { customToken: data?.customToken }
              : {})
          }
        });

        if (isValidArray(data?.users)) {
          yield setAbdmHealthIds(
            data.users.map((user) => ({
              healthId: user.abhaAddress,
              patientId: user.patientId
            }))
          );
        } else {
          yield setAbdmHealthIds([]);
        }

        if (isValidObject(data?.accounts?.[0])) {
          yield put({
            type: "SET_ABHA_NUMBER_DATA",
            payload: { data: data.accounts?.[0] }
          });
        }

        if (transactionId) {
          setTransactionId(transactionId, patients.transaction?.phoneNumber);
        }

        const query = phoneNumber ? `&mobile=${phoneNumber}` : "";

        navigate(`/abdm/list/?authMode=${method}${query}`, { replace: true });
      }
    }
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* createHealthIdWorker(action) {
  try {
    yield setPatientsLoading(true);
    const response = yield createHealthId(
      store.getState().auth.data.accessToken,
      {
        ...action.payload.data,
        password: generateEncryptionValue(action.payload.data.password, "PHR"),
        patientProfileDetails: {
          ...action.payload.data.patientProfileDetails,
          ...(isValidString(action.payload.data.patientProfileDetails.email)
            ? {
                email: generateEncryptionValue(
                  action.payload.data.patientProfileDetails.email,
                  "PHR"
                )
              }
            : {})
        }
      }
    );
    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      if (isValidString(data?.patient.patientId)) {
        // yield put({
        //   type: "SET_CURRENT_PATIENT_PROFILE_ID",
        //   payload: {
        //     currentProfile: data?.patient.patientId
        //   }
        // });

        if (isValidObject(data?.phrAddress)) {
          yield setAbdmHealthIds(data?.phrAddress);
        }

        if (isValidObject(data?.tokens)) {
          const { accessToken } = store.getState().patients;
          yield put({
            type: "SET_ABDM_ACCESS_TOKEN",
            payload: {
              abdmAccessToken: {
                ...accessToken,
                [data?.patient.patientId]: data.tokens
              }
            }
          });

          const authData = store.getState().auth.data;

          const isSameNumber =
            authData?.phoneNumber?.toString()?.replace("+91", "") ===
            response?.data?.phrDetails?.mobile?.toString()?.replace("+91", "");

          const profileData = {
            abhaAddress: response?.data?.patient?.healthId,
            fullName: response?.data?.patient?.name,
            gender: response?.data?.phrDetails?.gender,
            abhaNumber: response?.data?.phrDetails?.abhaNumber,
            status: response?.data?.phrDetails?.abhaNumber
              ? "ACTIVE"
              : "INACTIVE",
            kycStatus: response?.data?.phrDetails?.abhaNumber
              ? "VERIFIED"
              : "PENDING",
            age: getAge(response?.data?.phrDetails?.dateOfBirth),
            patientId: response?.data?.patient?.patientId
          };

          console.log(isSameNumber, "isSameNumber", profileData);

          yield put({
            type: "SET_AUTH_INFO",
            payload: {
              ...authData,
              ...(data.tokens.token ? { abdmToken: data.tokens.token } : {}),
              ...(data.tokens.refreshToken
                ? { ABDMRefreshToken: data.tokens.token }
                : {}),
              ...(isSameNumber
                ? {
                    validProfiles: [
                      ...(authData.validProfiles || []),
                      profileData
                    ]
                  }
                : {})
            }
          });

          if (!isSameNumber) {
            console.warn(
              "Mobile number associated with ABHA profile does not match with authenticated user's mobile number. Hence not adding ABHA profile to user's auth data."
            );
          }
        }
        yield put({
          type: "SET_RECENTLY_CREATED_ABHA_ID_DATA",
          payload: {
            recentlyCreatedABHAIdData: {
              ...data?.patient,
              accessToken: data?.tokens,
              customToken: data?.customToken
            }
          }
        });
      }

      setSuccessStatus(data?.message);
      action.payload.navigate("/abdm/create/success", { replace: true });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* getPatientsCareContextWorker() {
  try {
    yield setPatientsLoading(true);

    const { patients, auth } = store.getState();
    const { currentProfile, accessToken, careContexts } = patients;

    const abdmAccessToken = accessToken?.[currentProfile]?.token;

    if (!abdmAccessToken) {
      yield setPatientsLoading(false);
      return;
    }

    const response = yield getCareContexts(
      abdmAccessToken,
      auth.data.accessToken,
      currentProfile
    );

    if (response?.success && Array.isArray(response?.data?.patient?.links)) {
      const careContextsData = response.data.patient.links.reduce(
        (acc, link) => {
          const hipId = link.hip.id;

          if (!acc[hipId]) {
            acc[hipId] = [];
          }

          acc[hipId].push(link);

          return acc;
        },
        {}
      );

      yield put({
        type: "SET_PATIENTS_CARE_CONTEXTS",
        payload: {
          ...careContexts,
          [currentProfile]: careContextsData
        }
      });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    yield setErrorStatus(error);
  }
}

function* getPatientsConsentArtefactWorker() {
  try {
    yield setPatientsLoading(true);

    const { patients, auth } = store.getState();
    const { currentProfile, accessToken, consentArtefact } = patients;

    const abdmAccessToken = accessToken?.[currentProfile]?.token;

    if (!abdmAccessToken) {
      yield setPatientsLoading(false);
      return;
    }

    const response = yield getConsentArtefact(
      abdmAccessToken,
      auth.data.accessToken,
      currentProfile
    );

    if (response?.success === true) {
      const consentArtefactData = response.data.consentArtefacts.reduce(
        (acc, item) => {
          if (item.status === "GRANTED") {
            const key = item.consentDetail.hip.id;
            acc[key] = item;
          }
          return acc;
        },
        {}
      );

      yield put({
        type: "SET_PATIENTS_CONSENT_ARTEFACT",
        payload: {
          ...consentArtefact,
          [currentProfile]: consentArtefactData
        }
      });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    yield setErrorStatus(error);
  }
}

function* getPatientsRequestsWorker(action) {
  // background refreshes (polling, focus, notifications) skip the loading
  // shimmer and the error toast
  const silent = action?.payload?.silent === true;
  try {
    if (!silent) yield setPatientsLoading(true);

    const { patients, auth } = store.getState();
    const { currentProfile, accessToken } = patients;

    const response = yield getPatientRequests(
      auth.data.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile
    );

    if (!response?.success) {
      throw throwError(response);
    }

    const requests = {};

    const mapRequests = (arr, type, idKey) =>
      arr
        .filter((item) => Boolean(item?.[idKey]))
        .map((item) => ({
          ...item,
          type,
          id: item[idKey]
        }));

    if (isValidArray(response?.data?.consents?.requests)) {
      requests.consents = mapRequests(
        response.data.consents.requests,
        "consent",
        "requestId"
      );
    }

    if (isValidArray(response?.data?.subscriptions?.requests)) {
      requests.subscriptions = mapRequests(
        response.data.subscriptions.requests,
        "subscription",
        "subscriptionId"
      );
    }

    if (isValidArray(response?.data?.lockerSetups?.requests)) {
      requests.lockerSetups = response.data.lockerSetups.requests.map(
        (item) => {
          const status = Object.values(item).some(
            (e) => e.status === consentStatus.expired
          )
            ? consentStatus.expired
            : Object.values(item).some((e) => e.status === consentStatus.denied)
            ? consentStatus.denied
            : Object.values(item).some(
                (e) => e.status === consentStatus.pending
              )
            ? consentStatus.pending
            : item.authorization?.status === item.subscription?.status
            ? item.authorization.status
            : item.status;

          return {
            ...item,
            status,
            type: "lockerSetup",
            id: item.subscription?.id
          };
        }
      );
    }

    if (isValidArray(response?.data?.authorizations?.requests)) {
      requests.authorizations = mapRequests(
        response.data.authorizations.requests,
        "authorization",
        "requestId"
      );
    }

    yield put({
      type: "SET_PATIENTS_REQUESTS",
      payload: {
        ...(store.getState().patients.requests || {}),
        [currentProfile]: requests
      }
    });

    const chunkArray = (arr, size) =>
      Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
        arr.slice(i * size, i * size + size)
      );

    const subscriptionIds = (requests.subscriptions || []).map((d) => d.id);
    const batches = chunkArray(subscriptionIds, 10);

    for (const batch of batches) {
      const responses = yield Promise.all(
        batch.map((id) =>
          getUpdatedRequest(
            auth.data.accessToken,
            accessToken?.[currentProfile]?.token,
            currentProfile,
            { type: "subscription", id }
          )
            .then((res) => ({ ...res, id }))
            .catch((error) => ({
              success: false,
              data: { message: error?.message },
              id
            }))
        )
      );

      let requestsArray =
        store.getState()?.patients.requests?.[currentProfile]?.subscriptions ||
        [];

      responses.forEach(({ success, data, id }) => {
        if (!success) {
          setErrorStatus({
            code: "custom",
            message: data?.message
          });
          return;
        }

        const source = data.includedSources?.[0];
        const isExpired = +new Date(source.period.to) < +new Date();

        requestsArray = requestsArray.map((item) =>
          item.id === id
            ? {
                ...item,
                ...data,
                type: "subscription",
                includedSources: [
                  {
                    ...source,
                    status: isExpired ? "EXPIRED" : source.status
                  }
                ],
                status: isExpired ? "EXPIRED" : source.status,
                hiu: data.requester
              }
            : item
        );
      });

      yield put({
        type: "SET_PATIENTS_REQUESTS",
        payload: {
          ...store.getState().patients.requests,
          [currentProfile]: {
            ...store.getState().patients.requests[currentProfile],
            subscriptions: requestsArray
          }
        }
      });
    }

    if (!silent) yield setPatientsLoading(false);
  } catch (error) {
    // stay quiet on background refreshes, except for a dead ABDM session —
    // setErrorStatus is what logs the health ID out
    if (silent && !isAbdmSessionError(error?.message)) {
      console.error("Background consent list refresh failed:", error);
      return;
    }
    yield setPatientsLoading(false);
    yield setErrorStatus(error);
  } finally {
    // takeLatest cancels this when a newer fetch starts — don't leave the
    // shimmer on
    if (!silent && (yield cancelled())) {
      yield setPatientsLoading(false);
    }
  }
}

// ABDM applies approve/deny/revoke asynchronously, so the refetch that runs
// when the list remounts can still see the old status — refetch once more
// after it settles
function* schedulePatientsRequestsRefreshWorker() {
  yield delay(3000);
  yield put({
    type: "GET_PATIENTS_REQUESTS",
    payload: { silent: true }
  });
}

function* getPatientsUpdatedRequestsWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { patients, auth } = store.getState();
    const { currentProfile, accessToken } = patients;
    const requestsState = patients.requests || {};

    const { type, id } = action.payload.data;

    const dataToBeChanged = requestsState?.[currentProfile]?.[`${type}s`]?.find(
      (d) => d.requestId === id
    );

    if (type === "consent") {
      const { success, data } = yield getUpdatedConsentArtefactRequest(
        auth.data.accessToken,
        accessToken?.[currentProfile]?.token,
        currentProfile,
        {
          type,
          id: dataToBeChanged?.requestId
        }
      );

      if (success === false) {
        setErrorStatus({
          code: "custom",
          message: data?.message
        });
      }

      if (success === true) {
        const requestsArray =
          requestsState?.[currentProfile]?.[`${type}s`] || [];

        const dataToBeAdded = data.filter(
          (d) => d.consentDetail?.hiu?.id === dataToBeChanged?.hiu?.id
        );

        // patch only the consent that changed
        const updatedArray = requestsArray.map((item) =>
          item.requestId === id
            ? {
                ...item,
                status: dataToBeAdded?.[0]?.status,
                signature: dataToBeAdded?.[0]?.signature,
                accessTo: dataToBeAdded?.map((d) => ({
                  hipId: d.consentDetail?.hip?.id,
                  hiuId: d.consentDetail?.hiu?.id,
                  consentId: d.consentDetail?.consentId
                }))
              }
            : item
        );

        yield put({
          type: "SET_PATIENTS_REQUESTS",
          payload: {
            ...requestsState,
            [currentProfile]: {
              ...requestsState?.[currentProfile],
              [`${type}s`]: updatedArray
            }
          }
        });
      }
    }

    if (type === "subscription") {
      const { success, data } = yield getUpdatedRequest(
        auth.data.accessToken,
        accessToken?.[currentProfile]?.token,
        currentProfile,
        {
          type,
          id: dataToBeChanged?.subscriptionId
        }
      );

      if (success === false) {
        setErrorStatus({
          code: "custom",
          message: data?.message
        });
      }

      if (success === true) {
        const requestsArray =
          requestsState?.[currentProfile]?.[`${type}s`] || [];

        const updatedArray = requestsArray.map((item) =>
          item.requestId === id
            ? {
                ...data,

                includedSources: [
                  {
                    ...data.includedSources?.[0],
                    status:
                      +new Date(data.includedSources?.[0].period.to) <
                      +new Date()
                        ? "EXPIRED"
                        : data.includedSources?.[0]?.status
                  }
                ],
                status:
                  +new Date(data.includedSources?.[0].period.to) < +new Date()
                    ? "EXPIRED"
                    : data.includedSources?.[0]?.status,
                requestId: id,
                hiu: data.requester
              }
            : item
        );

        yield put({
          type: "SET_PATIENTS_REQUESTS",
          payload: {
            ...requestsState,
            [currentProfile]: {
              ...requestsState?.[currentProfile],
              [`${type}s`]: updatedArray
            }
          }
        });
      }
    }
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    yield setErrorStatus(error);
  }
}

function* linkingTokenDataWorker(action) {
  try {
    const { patients } = store.getState();
    yield put({
      type: "SET_LINKING_TOKEN_DETAILS",
      payload: {
        ...patients.linkingToken,
        linkingTokenData: action.payload.linkingTokenData
      }
    });
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* denyConsentRequestWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { auth, patients } = store.getState();
    const { accessToken, currentProfile } = patients;

    const response = yield denyRequests(
      auth.data?.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile,
      {
        requestId: action.payload.requestId,
        reason: action.payload.denyReason
      },
      "consentRequest"
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      if (typeof action.payload.navigate === "function") {
        action.payload.navigate("/settings", { replace: true });
      }
      yield put({ type: "SCHEDULE_PATIENTS_REQUESTS_REFRESH" });
    }
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* denySubscriptionRequestWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { auth, patients } = store.getState();
    const { accessToken, currentProfile } = patients;

    const response = yield denyRequests(
      auth.data?.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile,
      {
        subscriptionRequestId: action.payload.requestId,
        reason: action.payload.denyReason
      },
      "subscription"
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      if (typeof action.payload.navigate === "function") {
        action.payload.navigate("/settings", { replace: true });
      }
      yield put({ type: "SCHEDULE_PATIENTS_REQUESTS_REFRESH" });
    }
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* denyAuthorizationRequestWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { auth, patients } = store.getState();
    const { accessToken, currentProfile } = patients;

    const response = yield denyRequests(
      auth.data?.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile,
      {
        requestId: action.payload.requestId
        // reason: action.payload.denyReason // add if needed
      },
      "authorization"
    );

    if (response?.success) {
      setSuccessStatus(response.data?.message);
      if (typeof action.payload.navigate === "function") {
        action.payload.navigate("/settings", { replace: true });
      }
      yield put({ type: "SCHEDULE_PATIENTS_REQUESTS_REFRESH" });
    }
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* logoutHealthIdWorker() {
  try {
    yield put({
      type: "REMOVE_ABDM_ACCESS_TOKEN"
    });
  } catch (error) {
    setErrorStatus(error);
  }
}

function* createDemographicWorker(action) {
  try {
    yield setPatientsLoading(true);
    yield createDemographic(action.payload.profileName);
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* setTransactionIdWorker(action) {
  yield put({
    type: "SET_TRANSACTION_ID",
    payload: {
      transactionId: action.payload.transactionId || null,
      phoneNumber: action.payload.phoneNumber || null
    }
  });
}

function* acceptConsentRequestWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { patients, auth } = store.getState();
    const { currentProfile, requests, careContexts, accessToken } = patients;
    const consentRequesterData = requests?.[currentProfile]?.consents?.find(
      (c) => c.requestId === action.payload.requestId
    );

    if (!consentRequesterData) {
      setErrorStatus({ code: "custom", message: "Consent request not found" });
      yield setPatientsLoading(false);
      return;
    }

    const consentRequestBodyData = [];
    const allCareContexts = Object.values(careContexts?.[currentProfile] || {});

    const buildConsentEntries = (entries, isLocker) => {
      Object.keys(entries).forEach((hipId) => {
        const entry = entries?.[hipId];

        if (!entry) {
          return;
        }

        const selectedContexts = entry.selectedCareContexts || [];

        if (!selectedContexts.length) {
          return;
        }

        const filteredContexts = selectedContexts.filter((ref) => {
          if (!isLocker) return true;
          if (entry.clone) return true;
          return !ref?.endsWith("clone");
        });

        const consentCareContexts = filteredContexts.map((ref) => ({
          patientReference: currentProfile,
          careContextReference: ref
        }));

        if (!consentCareContexts.length) {
          return;
        }

        const finalEntry = {
          careContexts: consentCareContexts,
          purpose: { code: "CAREMGT" },
          hiTypes: entry.requestToAccess || [],
          hip: { id: hipId },
          permission: {
            accessMode: "VIEW",
            dataEraseAt: entry.dataEraseAt,
            dateRange: {
              from: entry.from,
              to: entry.to
            },
            frequency: { value: 1, unit: "HOUR", repeats: 2 }
          }
        };

        consentRequestBodyData.push(finalEntry);
      });
    };

    const providers = action.payload.requestData?.providers?.allProviders
      ? allCareContexts
          .flat()
          .filter((c) => c?.hip?.type !== "HEALTH_LOCKER")
          .reduce((acc, c) => {
            const hipId = c?.hip?.id;

            const contexts =
              c?.careContexts?.map((ctx) => ctx?.referenceNumber) || [];

            if (!contexts.length) return acc;

            acc[hipId] = {
              ...action.payload.requestData.providers.allProviders,
              selectedCareContexts: contexts
            };

            return acc;
          }, {})
      : action.payload.requestData?.providers || {};

    if (isValidObject(providers)) {
      buildConsentEntries(providers, false);
    }

    const healthLockers = action.payload.requestData?.healthLockers
      ?.allHealthLockers
      ? allCareContexts
          .flat()
          .filter((c) => c.hip.type === "HEALTH_LOCKER")
          .reduce(
            (acc, c) => ({
              ...acc,
              [c.hip.id]:
                action.payload.requestData.healthLockers.allHealthLockers
            }),
            {}
          )
      : action.payload.requestData?.healthLockers || {};

    if (isValidObject(healthLockers)) {
      buildConsentEntries(healthLockers, true);
    }

    const response = yield acceptRequest(
      auth.data?.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile,
      {
        requestId: action.payload.requestId,
        consents: consentRequestBodyData
      },
      "consentRequest"
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      action.payload.navigate("/settings", { replace: true });
      yield put({ type: "SCHEDULE_PATIENTS_REQUESTS_REFRESH" });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    setErrorStatus(error);
    yield setPatientsLoading(false);
  }
}

function* acceptSubscriptionRequestWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { patients, auth } = store.getState();
    const { accessToken, currentProfile } = patients;

    const abdmToken = accessToken?.[currentProfile]?.token;
    const nintoToken = auth.data.accessToken;

    let autoApproveData = { policyData: {} };
    let autoApproveResponse;
    let subscriptionRequestBodyData = {
      subscriptionRequestId: action.payload.requestId || "",
      isApplicableForAllHIPs: false,
      includedSources: [],
      excludedSources: []
    };

    const requesterData = patients.requests?.[
      currentProfile
    ]?.subscriptions?.find(
      (data) => data.requestId === action.payload.requestId
    );

    // Build includedSources for request body
    if (action.payload.requestData.allProviders) {
      const { allProviders } = action.payload.requestData;
      subscriptionRequestBodyData = {
        ...subscriptionRequestBodyData,
        isApplicableForAllHIPs: true,
        includedSources: [
          {
            categories: ["LINK", "DATA"],
            hiTypes: allProviders.requestToAccess,
            period: {
              from: allProviders.from,
              to: allProviders.to
            },
            purpose: {
              code: "CAREMGT",
              text: "Care Management",
              refUri: "www.abc.com"
            }
          }
        ]
      };

      if (action.payload.autoApprove) {
        autoApproveData = {
          ...autoApproveData,
          pin: action.payload.pin,
          policyData: {
            isApplicableForAllHIPs: true,
            includedSources: [
              {
                hiTypes: allProviders.requestToAccess,
                period: {
                  from: allProviders.from,
                  to: allProviders.to
                },
                purpose: {
                  code: "CAREMGT",
                  text: "Care Management",
                  refUri: "www.abc.com"
                }
              }
            ],
            excludedSources: [],
            hiu: { id: requesterData.hiu.id, name: requesterData.hiu.name }
          }
        };
      }
    } else {
      // Multiple HIPs scenario

      Object.keys(action.payload.requestData).forEach((hipId) => {
        const careContext = patients.careContexts?.[currentProfile]?.[
          hipId
        ].find((data) => data.hip.id === hipId);

        subscriptionRequestBodyData.includedSources.push({
          categories: ["LINK", "DATA"],
          hiTypes: action.payload.requestData[hipId].requestToAccess,
          period: {
            from: action.payload.requestData[hipId].from,
            to: action.payload.requestData[hipId].to
          },
          hip: { id: careContext.hip.id, name: careContext.hip.name },
          purpose: {
            code: "CAREMGT",
            text: "Care Management",
            refUri: "www.abc.com"
          }
        });
      });

      if (action.payload.autoApprove) {
        const includedSourcesData = Object.keys(action.payload.requestData).map(
          (hipId) => {
            const careContext = patients.careContexts?.[currentProfile]?.[
              hipId
            ].find((data) => data.hip.id === hipId);

            return {
              hiTypes: action.payload.requestData[hipId].requestToAccess,
              period: {
                from: action.payload.requestData[hipId].from,
                to: action.payload.requestData[hipId].to
              },
              hip: { id: careContext.hip.id, name: careContext.hip.name },
              purpose: {
                code: "CAREMGT",
                text: "Care Management",
                refUri: "www.abc.com"
              }
            };
          }
        );

        autoApproveData = {
          ...autoApproveData,
          pin: action.payload.pin,
          policyData: {
            isApplicableForAllHIPs: false,
            includedSources: includedSourcesData,
            excludedSources: [],
            hiu: { id: requesterData.hiu.id, name: requesterData.hiu.name }
          }
        };
      }
    }

    // Auto approve flow
    if (action.payload.autoApprove) {
      autoApproveResponse = yield createAutoApprovalPolicy(
        nintoToken,
        abdmToken,
        currentProfile,
        autoApproveData
      );
    }

    // Accept subscription request if autoApprove succeeded or not requested
    const canAcceptRequest =
      (action.payload.autoApprove && autoApproveResponse?.success) ||
      !action.payload.autoApprove;

    if (canAcceptRequest && !action.payload.edit) {
      const response = yield acceptRequest(
        nintoToken,
        abdmToken,
        currentProfile,
        subscriptionRequestBodyData,
        "subscription"
      );

      const { data, success } = response;

      if (success === false) {
        setErrorStatus({
          code: "custom",
          message: data?.message
        });
      }

      if (success === true) {
        setSuccessStatus(data?.message);
        action.payload.navigate("/settings", { replace: true });
        yield put({ type: "SCHEDULE_PATIENTS_REQUESTS_REFRESH" });
      }
    }
    // Edit subscription request flow
    if (action.payload.edit) {
      const subscriptionEditBodyData = { ...subscriptionRequestBodyData };
      delete subscriptionEditBodyData.subscriptionRequestId;
      const response = yield editSubscriptionRequest(
        nintoToken,
        abdmToken,
        currentProfile,
        {
          subscriptionId: requesterData.subscriptionId,
          ...(action.payload.requestData.allProviders
            ? {}
            : { isApplicableForAllHIPs: false }),
          hiuId: requesterData.hiu.id,
          ...subscriptionEditBodyData
        }
      );

      const { data, success } = response;

      if (success === false) {
        setErrorStatus({
          code: "custom",
          message: data?.message
        });
      }

      if (success === true) {
        setSuccessStatus(data?.message);
        action.payload.navigate?.("/settings", { replace: true });
        yield put({ type: "SCHEDULE_PATIENTS_REQUESTS_REFRESH" });
      }
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* acceptLockerRequestWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { patients, auth } = store.getState();
    const { accessToken, currentProfile } = patients;

    const abdmToken = accessToken?.[currentProfile]?.token;
    const nintoToken = auth.data.accessToken;

    const requesterData = patients.requests?.[
      currentProfile
    ]?.lockerSetups?.find((data) => data.id === action.payload.requestId);

    const lockerRequestBodyData = {
      lockerRequestId: action.payload.requestId,
      lockerId: requesterData.subscription.hiu.id,
      authRequestId: requesterData.authorization.requestId,
      lockerName: requesterData.subscription.hiu.name,
      isApplicableForAllHIPsForSubscription: false,
      isApplicableForAllHIPsForAutoApproval: false,
      includedSubscriptionSources: [],
      includedAutoApprovalSources: []
    };

    const buildSources = (requestData) =>
      Object.keys(requestData).map((requestId) => {
        const careContext = patients.careContexts?.[currentProfile]?.[
          requestId
        ].find((data) => data.hip.id === requestId);

        return {
          categories: ["LINK", "DATA"],
          hiTypes: requestData[requestId].requestToAccess,
          period: {
            from: requestData[requestId].from,
            to: requestData[requestId].to
          },
          hip: { id: careContext.hip.id, name: careContext.hip.name },
          purpose: {
            code: "CAREMGT",
            text: "Care Management",
            refUri: "www.abc.com"
          }
        };
      });

    if (action.payload.requestData.allProviders) {
      const { allProviders } = action.payload.requestData;
      const subscriptionSource = [
        {
          categories: ["LINK", "DATA"],
          hiTypes: allProviders.requestToAccess,
          period: { from: allProviders.from, to: allProviders.to },
          purpose: {
            code: "CAREMGT",
            text: "Care Management",
            refUri: "www.abc.com"
          }
        }
      ];

      lockerRequestBodyData.isApplicableForAllHIPsForSubscription = true;
      lockerRequestBodyData.isApplicableForAllHIPsForAutoApproval = true;
      lockerRequestBodyData.includedSubscriptionSources = subscriptionSource;

      if (action.payload.autoApprove) {
        lockerRequestBodyData.includedAutoApprovalSources = subscriptionSource;
      }
    } else {
      lockerRequestBodyData.includedSubscriptionSources = buildSources(
        action.payload.requestData
      );

      if (action.payload.autoApprove) {
        lockerRequestBodyData.includedAutoApprovalSources = buildSources(
          action.payload.requestData
        );
      }
    }

    const response = yield acceptRequest(
      nintoToken,
      abdmToken,
      currentProfile,
      lockerRequestBodyData,
      "lockerRequest"
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      action.payload.navigate("/settings", { replace: true });
      yield put({ type: "SCHEDULE_PATIENTS_REQUESTS_REFRESH" });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* acceptAuthorizationRequestWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { patients, auth } = store.getState();
    const { accessToken, currentProfile } = patients;

    const abdmToken = accessToken?.[currentProfile]?.token;
    const nintoToken = auth.data.accessToken;

    const response = yield acceptRequest(
      nintoToken,
      abdmToken,
      currentProfile,
      { requestId: action.payload.requestId },
      "authorization"
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      action.payload.navigate("/settings", { replace: true });
      yield put({ type: "SCHEDULE_PATIENTS_REQUESTS_REFRESH" });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* healthLockerAuthorizationWorker() {
  try {
    yield setPatientsLoading(true);

    const { patients, auth } = store.getState();
    const { currentProfile, accessToken } = patients;

    const response = yield lockerAuthorizationRequest(
      auth.data.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* addPatientsSubscriptionWorker(action) {
  try {
    let subscriptionData = {};

    Object.keys(action.payload.data).forEach((key) => {
      subscriptionData = {
        ...subscriptionData,
        [action.payload.data[key].patient.patientId]: {
          ...subscriptionData[key],
          [key]: action.payload.data[key]
        }
      };
    });
    const currentSubscriptions = store.getState().patients.subscriptions;
    yield put({
      type: "SET_PATIENT_SUBSCRIPTION",
      payload: {
        subscription: {
          ...currentSubscriptions,
          ...subscriptionData
        }
      }
    });
  } catch (error) {
    console.error("ERROR addPatientsSubscriptionWorker", error);
    setErrorStatus(error);
  }
}

function* revokeConsentRequestWorker(action) {
  try {
    yield setPatientsLoading(true);
    const state = store.getState();
    const { currentProfile, accessToken } = state.patients;
    const nintoAccessToken = state.auth.data.accessToken;

    const response = yield revokeRequest(
      nintoAccessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile,
      {
        pin: action.payload.pin,
        consentRequests: [action.payload.requestId]
      },
      "consentRequest"
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      action.payload.navigate?.("/settings", { replace: true });
      yield put({ type: "SCHEDULE_PATIENTS_REQUESTS_REFRESH" });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    console.error("ERROR revokeConsentRequestWorker", error);
    setErrorStatus(error);
  }
}

function* revokeAuthorizationRequestWorker(action) {
  try {
    yield setPatientsLoading(true);
    const state = store.getState();
    const { currentProfile, accessToken } = state.patients;
    const nintoAccessToken = state.auth.data.accessToken;

    const response = yield revokeRequest(
      nintoAccessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile,
      {
        requestId: action.payload.requestId
      },
      "authorization"
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      action.payload.navigate?.("/settings", { replace: true });
      yield put({ type: "SCHEDULE_PATIENTS_REQUESTS_REFRESH" });
    }
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    console.error("ERROR revokeAuthorizationRequestWorker", error);
    setErrorStatus(error);
  }
}

function* disableAutoApproveWorker(action) {
  try {
    yield setPatientsLoading(true);
    const { patients, auth } = store.getState();

    const { currentProfile, accessToken } = patients;

    const authAccessToken = auth.data.accessToken;

    const autoApprovalIds = isValidArray(action.payload.autoApprovalId)
      ? action.payload.autoApprovalId.filter(Boolean)
      : [action.payload.autoApprovalId];

    if (autoApprovalIds.length === 0) {
      yield setPatientsLoading(false);
      return;
    }

    const responses = yield Promise.all(
      autoApprovalIds.map((id) =>
        disableAutoApprovalPolicy(
          authAccessToken,
          accessToken?.[currentProfile]?.token,
          currentProfile,
          { autoApprovalId: id }
        )
      )
    );

    if (responses.every((res) => res?.success)) {
      setSuccessStatus("Auto approval policy disabled successfully");

      if (typeof action.payload.navigate === "function") {
        const path = `/abdm/subscription/${action.payload.requestId}`;

        action.payload.navigate(path, { replace: true });
      }
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    console.error("ERROR disableAutoApproveWorker", error);
    setErrorStatus(error);
  }
}

function* enableAutoApproveWorker(action) {
  try {
    yield setPatientsLoading(true);
    const { patients, auth } = store.getState();

    const { currentProfile, accessToken: patientsAccessToken } = patients;
    const accessToken = patientsAccessToken?.[currentProfile]?.token;
    const authAccessToken = auth.data.accessToken;
    const { requester, requestId, autoApprovalId } = action.payload;

    if (autoApprovalId) {
      const response = yield acceptAutoApprove(
        authAccessToken,
        accessToken,
        currentProfile,
        { autoApprovalId }
      );

      const { data, success } = response;

      if (success === false) {
        setErrorStatus({
          code: "custom",
          message: data?.message
        });
      }

      if (success === true) {
        setSuccessStatus(data?.message);
        action.payload.navigate?.(`/abdm/subscription/${requestId}`, {
          replace: true
        });
      }
    } else {
      const includedSourcesData = [
        {
          hiTypes: action.payload?.data.allProviders.requestToAccess,
          period: {
            from: action.payload?.data.allProviders.from,
            to: action.payload?.data.allProviders.to
          },
          purpose: {
            code: "CAREMGT",
            text: "Care Management",
            refUri: "www.abc.com"
          }
        }
      ];

      const requestData = {
        policyData: {
          isApplicableForAllHIPs: action.payload?.data.allProviders
            ? true
            : false,
          includedSources: includedSourcesData,
          excludedSources: [],
          hiu: {
            id: requester.id,
            name: requester.name
          }
        }
      };

      const response = yield createAutoApprovalPolicy(
        authAccessToken,
        accessToken,
        currentProfile,
        requestData
      );

      const { data, success } = response;

      if (success === false) {
        setErrorStatus({
          code: "custom",
          message: data?.message
        });
      }

      if (success === true) {
        setSuccessStatus(data?.message);
        action.payload.navigate?.(`/abdm/subscription/${requestId}`, {
          replace: true
        });
      }
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    console.error("ERROR enableAutoApproveWorker", error);
    setErrorStatus(error);
  }
}

function* createAutoApproveWorker(action) {
  try {
    yield setPatientsLoading(true);
    const { patients, auth } = store.getState();
    const { hiTypes, from, to, requester } = action.payload;
    const { currentProfile, accessToken: patientsAccessToken } = patients;
    const accessToken = patientsAccessToken?.[currentProfile]?.token;
    const authAccessToken = auth.data.accessToken;

    const includedSourcesData = [
      {
        hiTypes,
        period: {
          from,
          to
        },
        purpose: {
          code: "CAREMGT",
          text: "Care Management",
          refUri: "www.abc.com"
        }
      }
    ];

    const requestData = {
      policyData: {
        isApplicableForAllHIPs: true,
        includedSources: includedSourcesData,
        excludedSources: [],
        hiu: {
          id: requester?.id,
          name: requester?.name
        }
      }
    };

    const response = yield createAutoApprovalPolicy(
      authAccessToken,
      accessToken,
      currentProfile,
      requestData
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      action.payload.navigate?.(`/settings/autoApproval`, { replace: true });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    console.error("ERROR enableAutoApproveWorker", error);
    setErrorStatus(error);
  }
}

function* addAutoApprovalPolicyWorker(action) {
  try {
    yield put({
      type: "SET_AUTO_APPROVAL_POLICIES",
      payload: {
        autoApprovalPolicies: action.payload.data
      }
    });

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    console.error("ERROR addAutoApprovalPolicyWorker", error);
    setErrorStatus(error);
  }
}

function* getHealthIdInformationWorker() {
  try {
    const { patients, auth } = store.getState();
    const { accessToken, currentProfile } = patients;
    if (
      typeof currentProfile !== "string" ||
      typeof accessToken?.[currentProfile]?.token !== "string"
    ) {
      return;
    }

    const response = yield getHealthIdData(
      auth.data.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile
    );

    if (response?.success) {
      const { ...restData } = response.data;

      yield put({
        type: "SET_HEALTH_ID_INFORMATION",
        payload: {
          data: { [currentProfile]: restData }
        }
      });
    }
  } catch (error) {
    setErrorStatus(error);
  }
}

function* editProfileWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { auth, patients } = store.getState();
    const { currentProfile, accessToken } = patients;

    const response = yield editHealthIdData(
      auth.data.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile,
      action.payload.data
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message || "Profile updated successfully");
      getHealthIdInformation();
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    yield setErrorStatus(error);
  }
}

function* saveEditProfileWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { auth, patients } = store.getState();
    const { currentProfile, accessToken } = patients;
    const {
      profileData,
      phoneNumber,
      email,
      hasProfileChanges,
      hasPhoneChange,
      hasEmailChange
    } = action.payload;

    if (hasProfileChanges) {
      const response = yield editHealthIdData(
        auth.data.accessToken,
        accessToken?.[currentProfile]?.token,
        currentProfile,
        profileData
      );

      const { data, success } = response;

      if (success === false) {
        setErrorStatus({ code: "custom", message: data?.message });
        yield setPatientsLoading(false);
        return;
      }

      if (success === true) {
        setSuccessStatus(data?.message || "Profile updated successfully");
        getHealthIdInformation();
      }
    }

    if (hasPhoneChange) {
      const response = yield generateOTPForUpdatePhoneNumberOrEmail(
        auth.data.accessToken,
        accessToken?.[currentProfile]?.token,
        currentProfile,
        {
          value: generateEncryptionValue(phoneNumber.replace("+91", ""), "PHR"),
          authMode: getValidAuthMode("Mobile")
        }
      );

      const { data, success } = response;

      if (success === false) {
        setErrorStatus({ code: "custom", message: data?.message });
      } else if (success === true) {
        setSuccessStatus(data?.message);
        const transactionId = data?.transactionId || data?.sessionId;
        if (transactionId) setTransactionId(transactionId, phoneNumber);
      }
    } else if (hasEmailChange) {
      const response = yield generateOTPForUpdatePhoneNumberOrEmail(
        auth.data.accessToken,
        accessToken?.[currentProfile]?.token,
        currentProfile,
        {
          value: generateEncryptionValue(email, "PHR"),
          authMode: getValidAuthMode("Email")
        }
      );

      const { data, success } = response;

      if (success === false) {
        setErrorStatus({ code: "custom", message: data?.message });
      } else if (success === true) {
        setSuccessStatus(data?.message);
        const transactionId = data?.transactionId || data?.sessionId;
        if (transactionId) setTransactionId(transactionId, email);
      }
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* verifyOTPToUpdatePhoneNumberOrEmailWorker(action) {
  try {
    yield setPatientsLoading(true);
    const { auth, patients } = store.getState();
    const authToken = auth.data.accessToken;
    const patientToken = patients.accessToken?.[patients.currentProfile]?.token;
    const transactionId = patients?.transaction?.id;
    const { authMode, navigate, value, data } = action.payload;

    const validAuthMode = getValidAuthMode(action.payload.authMode);

    const isPhoneNumbersMethod = validAuthMode === "MOBILE_OTP";

    const updatedData = {
      authMode: getValidAuthMode(authMode),
      value: isPhoneNumbersMethod
        ? generateEncryptionValue(value.replace("+91", ""), "PHR")
        : generateEncryptionValue(value, "PHR"),
      transactionId,
      ...(authMode === "Phone"
        ? { updatedMobile: data }
        : { updatedEmail: data }),
      abhaNumber: patients?.profiles?.[patients.currentProfile]?.abhaNumber
    };

    const response = yield verifyOTPForUpdatePhoneNumberOrEmail(
      authToken,
      patientToken,
      patients.currentProfile,
      updatedData
    );

    const { success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: response?.data?.message || response?.data?.error?.message
      });
    }
    console.log(
      data,
      auth.data.phoneNumber,
      authMode === "Phone" && data !== auth.data.phoneNumber,
      "authMode === Phone && data !== auth.data.phoneNumber"
    );
    if (success === true) {
      console.log(
        authMode === "Phone" && data !== auth.data.phoneNumber,
        "authMode === Phone && data !== auth.data.phoneNumber"
      );
      if (authMode === "Phone" && data !== auth.data.phoneNumber) {
        setSuccessStatus(response?.data?.message);
        yield put({
          type: "SET_AUTH_INFO",
          payload: {
            ...store.getState().auth.data,
            ...(response?.data.customToken
              ? { customToken: response?.data.customToken }
              : {})
          }
        });
        navigate("/settings/editProfile/confirmLogin");
        setTransactionId(null);
      } else {
        setSuccessStatus(response?.data?.message);
        navigate("/", { replace: true });
        setTransactionId(null);
        if (response.data?.idToken) {
          putAuthInfo({
            accessToken: response.data.idToken,
            uid: auth.data.uid,
            phoneNumber: data,
            displayName: auth.data.displayName
          });
        }
      }
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* generateOTPToUpdatePhoneNumberOrEmailWorker(action) {
  try {
    yield setPatientsLoading(true);
    const { auth, patients } = store.getState();
    const { accessToken, currentProfile } = patients;

    const validAuthMode = getValidAuthMode(action.payload.authMode);

    const isPhoneNumbersMethod = validAuthMode === "MOBILE_OTP";

    const response = yield generateOTPForUpdatePhoneNumberOrEmail(
      auth.data.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile,
      {
        value: isPhoneNumbersMethod
          ? generateEncryptionValue(
              action.payload.value.replace("+91", ""),
              "PHR"
            )
          : generateEncryptionValue(action.payload.value, "PHR"),
        authMode: validAuthMode
      }
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      const transactionId = data?.transactionId || data?.sessionId;
      if (transactionId) {
        setTransactionId(transactionId, action.payload.value);
      }
    }
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* resetAbhaPasswordWorker(action) {
  try {
    yield setPatientsLoading(true);
    const { auth, patients } = store.getState();
    const { accessToken, currentProfile } = patients;

    const response = yield abhaAddressResetPassword(
      auth.data.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile,
      { password: generateEncryptionValue(action.payload.password, "PHR") }
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      action.payload.navigate?.("/settings", { replace: true });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* setRequestsFilterDataWorker(action) {
  try {
    const { patients } = store.getState();

    const filterState = patients.requestsFilter;
    const { filterType, clinics, requests, status } = filterState;

    const toggleItemInArray = (array, item) => {
      const newArray = [...array];
      const index = newArray.indexOf(item);
      if (index > -1) newArray.splice(index, 1);
      else newArray.push(item);
      return newArray;
    };

    switch (action.payload.filterBy) {
      case "filterType":
        if (action.payload.id !== filterType) {
          yield put({
            type: "SET_FILTER_TYPE",
            payload: { id: action.payload.id }
          });
        }
        break;

      case "clinics":
        yield put({
          type: "SET_CLINICS_FILTER",
          payload: { clinics: toggleItemInArray(clinics, action.payload.id) }
        });
        break;

      case "requests":
        yield put({
          type: "SET_REQUESTS_FILTER",
          payload: { requests: toggleItemInArray(requests, action.payload.id) }
        });
        break;

      case "status":
        yield put({
          type: "SET_STATUS_FILTER",
          payload: { status: toggleItemInArray(status, action.payload.id) }
        });
        break;

      case "clear":
        yield put({ type: "CLEAR_REQUEST_FILTER" });
        break;

      default:
        break;
    }
  } catch (error) {
    console.error("ERROR setRequestsFilterDataWorker", error);
  }
}

function* linkHealthIdNumberWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { auth, patients } = store.getState();
    const { profiles, currentProfile, accessToken } = patients;
    const abdmAccessToken = accessToken?.[currentProfile]?.token;
    const nintoAccessToken = auth.data.accessToken;
    const callLinkAbhaNumber = (data, type) =>
      linkAbhaNumber(
        nintoAccessToken,
        abdmAccessToken,
        currentProfile,
        data,
        type
      );

    const callDeLinkAbhaNumber = (data, type) =>
      deLinkAbhaNumber(
        nintoAccessToken,
        abdmAccessToken,
        currentProfile,
        data,
        type
      );

    switch (action.payload.type) {
      case "search": {
        // const response = yield callLinkAbhaNumber(
        //   action.payload.data,
        //   "search"
        // );
        // if (response.success) {
        setAuthModes(["MOBILE_OTP", "AADHAAR_OTP"]);
        // }
        break;
      }

      case "init": {
        const response = yield callLinkAbhaNumber(
          action.payload.data,
          "sendOtp"
        );

        const { data, success } = response;

        if (success === false) {
          setErrorStatus({
            code: "custom",
            message: data?.message
          });
        }

        if (success === true) {
          setSuccessStatus(data?.message);
          setAuthModes(null);
          yield put({
            type: "SET_TRANSACTION_ID",
            payload: {
              transactionId: response.data.transactionId || null,
              phoneNumber: auth.data.phoneNumber || null
            }
          });
        }
        break;
      }

      case "verifyOtpLink":
      case "verifyOtpDeLink": {
        const response = yield callLinkAbhaNumber(
          {
            transactionId: action.payload.data.transactionId,
            value: action.payload.data.value,
            authMode: action.payload.data.authMode
          },
          "verifyOtp"
        );

        if (response.success) {
          const confirmFn =
            action.payload.type === "verifyOtpLink"
              ? callLinkAbhaNumber
              : callDeLinkAbhaNumber;

          const result = yield confirmFn(
            {
              transactionId: action.payload.data.transactionId,
              ...(action.payload.data.abhaNumber
                ? { abhaNumber: action.payload.data.abhaNumber }
                : {})
            },
            "confirm"
          );

          const { data, success } = result;

          if (success === false) {
            setErrorStatus({
              code: "custom",
              message: data?.message
            });
          }

          if (success === true) {
            setSuccessStatus(`Congratulations! ${
              profiles?.[currentProfile]?.name || ""
            } Your ABHA
number is now linked to your existing ABHA address. ABHA number is visible on your
profile.`);
            // getHealthIdInformation();
            setTransactionId(null);

            yield put({
              type: "SET_SHOW_SUCCESS",
              payload: {
                data: {
                  healthId: {
                    unLink: action.payload.type === "verifyOtpDeLink",
                    link: action.payload.type === "verifyOtpLink",
                    create: false
                  }
                }
              }
            });
          }
        }
        break;
      }

      default:
        break;
    }

    if (action.payload.modal) {
      action.payload.modal(false);
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
    console.error("ERROR linkHealthIdNumberWorker", error);
  }
}

function* setAuthModesWorker(action) {
  yield put({
    type: "PUT_AUTH_MODE",
    payload: {
      data: action.payload.data
    }
  });
}

function* generateLinkOrUnlinkAbhaAddressWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { auth, patients } = store.getState();
    const { currentProfile, accessToken } = patients;
    const abdmAccessToken = accessToken?.[currentProfile]?.token;
    const nintoAccessToken = auth.data.accessToken;

    const response = yield generateOtpForUnlinkAbhaAddressFromAbhaNumber(
      nintoAccessToken,
      abdmAccessToken,
      action.payload
    );

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setAuthModes(null);
      if (response.data?.authMethods) {
        setAuthModes(response.data.authMethods);
      }

      yield put({
        type: "SET_TRANSACTION_ID",
        payload: {
          transactionId: response.data?.transactionId || null,
          phoneNumber: auth.data.phoneNumber || null
        }
      });
      setSuccessStatus(data?.message);
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* confirmLinkOrUnlinkAbhaAddressWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { auth, patients } = store.getState();
    const { currentProfile, accessToken } = patients;

    const abdmAccessToken = accessToken?.[currentProfile]?.token;
    const nintoAccessToken = auth.data.accessToken;

    const response = yield confirmUnlinkAbhaAddressFromAbhaNumber(
      nintoAccessToken,
      abdmAccessToken,
      action.payload
    );

    const result = yield linkOrUnlinkAbhaAddressFromAbhaNumber(
      nintoAccessToken,
      abdmAccessToken,
      {
        token: response.data?.token,
        abhaAddress: response.data?.data?.healthId
      },
      action.payload.linkAbhaAddress ? "link" : "delink"
    );

    const { data, success } = result;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      setSuccessStatus(data?.message);
      yield getHealthIdInformationWorker({ profileId: currentProfile });
      action.payload.navigate?.("/settings");
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
  }
}

function* setSelectedLinkedFacilityWorker(action) {
  yield put({
    type: "SET_SELECTED_LINKED_FACILITY",
    payload: {
      linkedFacilityId: action.payload.linkedFacilityId
    }
  });
}

function* setActiveSettingsMenuWorker(action) {
  yield put({
    type: "SET_ACTIVE_SETTINGS_MENU",
    payload: {
      menu: action.payload.menu
    }
  });
}

function* setConsentToPersonalDataWorker(action) {
  try {
    yield setPatientsLoading(true);
    yield addConsentAgreeToPersonalData(
      store.getState().patients.currentProfile
    );
    setSuccessStatus("Agreed successfully");
    action.payload.navigate("/locker/subscribe");
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
  }
}

function* getNewLinkingTokenWorker(action) {
  try {
    yield setPatientsLoading(true);
    const { auth, patients } = store.getState();
    const { currentProfile, accessToken, profiles } = patients;

    const profileData = profiles?.[currentProfile];

    const response = yield generateLinkingToken(
      auth.data.accessToken,
      accessToken?.[currentProfile]?.token,
      currentProfile,
      {
        patient: {
          patientId: currentProfile,
          ...(profileData?.healthId ? { healthId: profileData.healthId } : {}),
          ...(profileData?.abhaNumber
            ? { abhaNumber: profileData.abhaNumber.replace(/\D/g, "") }
            : {}),
          ...(profileData?.phoneNumber
            ? { phoneNumber: profileData.phoneNumber }
            : {}),
          ...(profileData?.name ? { name: profileData.name } : {}),
          ...(profileData?.gender ? { gender: profileData.gender } : {}),
          ...(profileData?.dob?.year
            ? { yearOfBirth: Number(profileData.dob.year) }
            : {})
        }
      }
    );

    const { success, data } = response;
    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true && typeof action.payload?.navigate === "function") {
      action.payload.navigate("/patientTimeline/upload");
    }
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* confirmAbdmLoginWorker(action) {
  try {
    yield setPatientsLoading(true);
    const authData = store.getState().auth.data;
    const patients = store.getState().patients;

    const { profileId, authMode, txnId, token, healthId } = action.payload;

    const response = yield confirmLoginForAbdmAuth(authData.accessToken, {
      healthId,
      transactionId: txnId,
      ...(authMode ? { authMode } : {}),
      ...(profileId ? { patientId: profileId } : {}),
      ...(token ? { token } : {})
    });

    const { data, success } = response;

    if (success === false) {
      setErrorStatus({
        code: "custom",
        message: data?.message
      });
    }

    if (success === true) {
      if (action.payload.isRegister && authData?.customToken) {
        const tokenResponse = yield signInWithAuthCustomToken(
          authData?.customToken
        );

        yield put({
          type: "SET_AUTH_INFO",
          payload: {
            ...store.getState().auth.data,
            transactionId: txnId,
            ...(tokenResponse.user.accessToken
              ? { accessToken: tokenResponse.user.accessToken }
              : {})
          }
        });
        yield switchWithCustomToken(
          authData?.customToken,
          txnId,
          authData?.abdmToken,
          authData?.authMode,
          data.token
        );
      }

      yield put({
        type: "SET_CURRENT_PATIENT_PROFILE_ID",
        payload: {
          currentProfile: data?.patient?.patientId || data?.patientId
        }
      });

      yield put({
        type: "SET_ABDM_ACCESS_TOKEN",
        payload: {
          abdmAccessToken: null
        }
      });

      yield put({
        type: "SET_ABDM_ACCESS_TOKEN",
        payload: {
          abdmAccessToken: {
            ...patients.accessToken,
            [data?.patient?.patientId || data?.patientId]:
              typeof data.token === "string"
                ? {
                    token: data.token
                  }
                : data.token
          }
        }
      });

      setAuthModes(null);
      setTransactionId(null);
      action.payload.navigate?.("/", { replace: true });
    }

    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

function* changePhoneNumberWorker(action) {
  try {
    yield setPatientsLoading(true);

    const { shouldChange, navigate } = action.payload;
    const { auth, patients } = store.getState();

    if (shouldChange) {
      const customTokenResponse = yield signInWithAuthCustomToken(
        auth.data.customToken
      );

      const refreshTokenResponse = yield refreshABDMToken(
        customTokenResponse.user.accessToken,
        {
          refreshToken:
            patients?.accessToken?.[patients.currentProfile]?.refreshToken ||
            auth.data.ABDMRefreshToken
        }
      );

      yield put({
        type: "SET_AUTH_INFO",
        payload: {
          accessToken: customTokenResponse.user.accessToken,
          uid: customTokenResponse.user.uid,
          phoneNumber: customTokenResponse.user.phoneNumber,
          displayName: customTokenResponse.user.displayName,
          customToken: auth.data.customToken,
          ABDMRefreshToken:
            patients?.accessToken?.[patients.currentProfile]?.refreshToken ||
            auth.data.ABDMRefreshToken
        }
      });

      yield put({ type: "FORCE_CLEAR_PATIENTS" });

      const currentProfileData =
        patients.healthIdData?.[patients.currentProfile];

      const healthId = currentProfileData?.abhaAddress;
      console.log({ token: refreshTokenResponse.data.token, healthId });
      const switchResponse = yield switchProfile(
        customTokenResponse.user.accessToken,
        patients.currentProfile,
        {
          token: refreshTokenResponse.data.token,
          healthId
        }
      );

      yield put({
        type: "SET_ABDM_ACCESS_TOKEN",
        payload: {
          abdmAccessToken: {
            [patients.currentProfile]: {
              token: switchResponse?.data
            }
          }
        }
      });

      yield put({
        type: "SET_ABDM_ACCESS_TOKEN",
        payload: {
          abdmAccessToken: {
            [patients.currentProfile]: {
              token: refreshTokenResponse.data.token
            }
          }
        }
      });

      yield put({
        type: "SET_CURRENT_PATIENT_PROFILE_ID",
        payload: { currentProfile: patients.currentProfile }
      });
      yield put({
        type: "PUT_SHOULD_LISTEN",
        payload: {
          data: true
        }
      });

      getHealthIdInformation();

      navigate("/", { replace: true });
    } else {
      yield put({
        type: "SET_CURRENT_PATIENT_PROFILE_ID",
        payload: { currentProfile: null }
      });

      navigate("/switchProfile");
    }
    yield setPatientsLoading(false);
  } catch (error) {
    yield setPatientsLoading(false);
    setErrorStatus(error);
  }
}

export default function* patientsWatcher() {
  yield all([
    takeEvery("GET_NEW_LINKING_TOKEN", getNewLinkingTokenWorker),
    takeEvery("CONFIRM_ABDM_LOGIN", confirmAbdmLoginWorker),
    takeEvery("CREATE_HEALTH_ID", createHealthIdWorker),
    takeEvery("RESET_ABHA_PASSWORD", resetAbhaPasswordWorker),
    takeEvery("SET_AUTH_MODES", setAuthModesWorker),
    takeEvery("ADD_PATIENTS_DEMOGRAPHICS", addPatientsDemographicsWorker),
    takeEvery("GET_MODES_FOR_ABDM_AUTH", getModesForAbdmAuthWorker),
    takeEvery("SWITCH_PATIENT_PROFILE", switchPatientsWorker),
    takeEvery("SEND_OTP_FOR_ABDM_AUTHENTICATION", sendOtpForAbdmAuthWorker),
    takeEvery("VERIFY_ABDM_AUTHENTICATION_OTP", verifyAbdmAuthOtpWorker),
    takeEvery("LINKING_TOKEN_DETAILS", linkingTokenDataWorker),
    takeLatest("GET_PATIENTS_CARE_CONTEXTS", getPatientsCareContextWorker),
    takeEvery("LOGOUT_HEALTH_ID", logoutHealthIdWorker),
    takeEvery("CREATE_PATIENTS_DEMOGRAPHIC", createDemographicWorker),
    takeEvery("PUT_TRANSACTION_ID", setTransactionIdWorker),
    takeLatest("GET_PATIENTS_REQUESTS", getPatientsRequestsWorker),
    takeLatest(
      "SCHEDULE_PATIENTS_REQUESTS_REFRESH",
      schedulePatientsRequestsRefreshWorker
    ),
    takeEvery(
      "GET_PATIENTS_UPDATED_REQUESTS",
      getPatientsUpdatedRequestsWorker
    ),
    takeEvery("ACCEPT_CONSENT_REQUEST", acceptConsentRequestWorker),
    takeEvery("ACCEPT_SUBSCRIPTION_REQUEST", acceptSubscriptionRequestWorker),
    takeEvery("ACCEPT_LOCKER_REQUEST", acceptLockerRequestWorker),
    takeEvery("ACCEPT_AUTHORIZATION_REQUEST", acceptAuthorizationRequestWorker),
    takeEvery("HEALTH_LOCKER_AUTHORIZATION", healthLockerAuthorizationWorker),
    takeEvery("DENY_CONSENT_REQUEST", denyConsentRequestWorker),
    takeEvery("DENY_SUBSCRIPTION_REQUEST", denySubscriptionRequestWorker),
    takeEvery("DENY_AUTHORIZATION_REQUEST", denyAuthorizationRequestWorker),
    takeEvery("CLEAR_ABDM_UNUSED_HEALTH_ID", clearUnusedHealthId),
    takeEvery("CLEAR_ABDM_LINKED_PROFILES", clearABDMLinkedProfiles),
    takeEvery("CLEAR_SHOW_SUCCESS", clearShowSuccess),
    takeEvery("ADD_PATIENTS_SUBSCRIPTION", addPatientsSubscriptionWorker),
    takeEvery("REVOKE_CONSENT_REQUEST", revokeConsentRequestWorker),
    takeEvery("REVOKE_AUTHORIZATION_REQUEST", revokeAuthorizationRequestWorker),
    takeEvery("DISABLE_AUTO_APPROVE", disableAutoApproveWorker),
    takeEvery("ENABLE_AUTO_APPROVE", enableAutoApproveWorker),
    takeEvery("CREATE_AUTO_APPROVE", createAutoApproveWorker),
    takeEvery("ADD_AUTO_APPROVAL_POLICIES", addAutoApprovalPolicyWorker),
    takeEvery("GET_HEALTH_ID_INFORMATION", getHealthIdInformationWorker),
    takeEvery("EDIT_PROFILE", editProfileWorker),
    takeEvery("SAVE_EDIT_PROFILE", saveEditProfileWorker),
    takeEvery(
      "GET_PATIENTS_CONSENT_ARTEFACT",
      getPatientsConsentArtefactWorker
    ),
    takeEvery(
      "VERIFY_OTP_TO_UPDATE_PHONE_NUMBER_OR_EMAIL",
      verifyOTPToUpdatePhoneNumberOrEmailWorker
    ),
    takeEvery(
      "GENERATE_OTP_TO_UPDATE_PHONE_NUMBER_OR_EMAIL",
      generateOTPToUpdatePhoneNumberOrEmailWorker
    ),
    takeEvery("SET_REQUESTS_FILTER_DATA", setRequestsFilterDataWorker),
    takeEvery(
      "GENERATE_LINK_OR_UNLINK_ABHA_ADDRESS_OTP",
      generateLinkOrUnlinkAbhaAddressWorker
    ),
    takeEvery(
      "CONFIRM_LINK_OR_UNLINK_ABHA_ADDRESS",
      confirmLinkOrUnlinkAbhaAddressWorker
    ),
    takeEvery("SELECTED_LINKED_FACILITY", setSelectedLinkedFacilityWorker),
    takeEvery("LINK_HEALTH_ID_NUMBER", linkHealthIdNumberWorker),
    takeEvery("SET_CONSENT_TO_PERSONAL_DATA", setConsentToPersonalDataWorker),
    takeEvery("CHANGE_PHONE_NUMBER", changePhoneNumberWorker),
    takeEvery("ACTIVE_SETTINGS_MENU", setActiveSettingsMenuWorker)
  ]);
}

function* setPatientsLoading(loadingState) {
  if (store.getState().patients.loading !== loadingState) {
    yield put({
      type: "SET_PATIENTS_LOADING",
      payload: {
        loading: loadingState
      }
    });
  }
}

function* setAbdmHealthIds(healthIdList) {
  const healthIds = Array.isArray(healthIdList) ? healthIdList : [];
  const { patients } = store.getState();

  if (!healthIds.length || !patients.profiles) {
    return;
  }

  const profiles = Object.values(patients.profiles);

  const usedHealthIds = healthIds.filter(({ healthId }) =>
    profiles.some((profile) => profile.healthId === healthId)
  );

  const unUsedHealthIds = healthIds.filter(
    ({ healthId }) => !profiles.some((profile) => profile.healthId === healthId)
  );

  yield put({
    type: "SET_ABDM_USED_HEALTH_ID",
    payload: { healthId: usedHealthIds }
  });

  yield put({
    type: "SET_ABDM_UNUSED_HEALTH_ID",
    payload: { healthId: unUsedHealthIds }
  });
}

function* switchWithCustomToken(
  accessToken,
  transactionId,
  abdmToken,
  authMode,
  validProfiles
) {
  try {
    yield setCustomAuthLoading(true);
    logout();

    yield put({
      type: "FORCE_CLEAR_DOWNLOADS"
    });

    yield put({
      type: "FORCE_CLEAR_DOCUMENTS"
    });

    yield put({
      type: "FORCE_CLEAR_NOTIFICATION"
    });

    yield put({
      type: "FORCE_CLEAR_PATIENTS"
    });

    const response = yield signInWithAuthCustomToken(accessToken);

    yield put({
      type: "SET_AUTH_INFO",
      payload: {
        accessToken: response.user.accessToken,
        uid: response.user.uid,
        phoneNumber: response.user.phoneNumber,
        displayName: response.user.displayName,
        transactionId,
        abdmToken,
        authMode,
        validProfiles
      }
    });

    yield setCustomAuthLoading(false);
  } catch (error) {
    yield setCustomAuthLoading(false);
    setErrorStatus(error);
  }
}

function* setCustomAuthLoading(loadingState) {
  yield put({
    type: "SET_CUSTOM_AUTH_LOADING",
    payload: {
      loading: loadingState
    }
  });
}

const getAge = (dateOfBirth) => {
  const [day, month, year] = dateOfBirth.split("-").map(Number);

  const today = new Date();
  const birthDate = new Date(year, month - 1, day);

  let age = today.getFullYear() - birthDate.getFullYear();

  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
};
